<template>
  <b-row>
    <ProfilePicture />
    <ProfileDetails
      :productsData="data.ProductGroups"
      :userData="data.generalInfo"
      v-if="propsReady"
    />
    <ProfileLocations :locationData="data.Locations" v-if="propsReady" />
  </b-row>
</template>

<script>
import ProfileDetails from "../../../components/profile/ProfileDetails";
import ProfileLocations from "../../../components/profile/ProfileLocations";
import ProfilePicture from "../../../components/profile/ProfilePicture";

export default {
  name: "ProfileSettings",
  components: {
    ProfilePicture,
    ProfileDetails,
    ProfileLocations,
  },
  data() {
    return {
      user: null,
      data: [],
      propsReady: false,
    };
  },
  methods: {
    getInfo() {
      let params = {};
      params = {
        userId: this.user,
      };
      this.$http
        .get("api/comcast_portal/profile/userInfo.php", { params })
        .then(
          (res) => {
            this.data = res.data;
            this.propsReady = true;
          },
          (err) => {
            console.log(err);
          }
        );
    },
  },
  mounted() {
    this.user = localStorage.getItem("comcast_user");
    this.getInfo();
  },
};
</script>

<style scoped></style>
